export default __webpack_public_path__ + "static/media/imgSupportQuotes.59b164ca.png";